import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { _HttpServices } from "../../../_services/_HttpServices";
import ReactTable from "../../../components/FilterTable";
import { Button } from "react-bootstrap";
import {
	IoMdCreate,
	IoIosAdd,
	IoMdDownload,
	IoMdTrash,
	IoMdDoneAll,
	IoIosClose,
	IoIosCheckmarkCircle,
	IoIosCloudUpload,
} from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Toast, Modal } from "react-bootstrap";
// Local imports
import Loader from "../../../components/Loader";
import moment from "moment";
import getExcel from "../../../_services/ExcelUtility";
import endPoints from "./../../../_services/endpoints";
const PriceUpdate = ({ dispatch, login }) => {
	const fileName = "Price Update";
	const history = useHistory();
	const [drugPriceList, setDrugPriceList] = useState([]);
	const [activDrugPriceList, setactivDrugPriceList] = useState([]);
	const [inactivDrugPriceList, setinactivDrugPriceList] = useState([]);
	const [showToaster, setShowToaster] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loggedInUserData, setLoggedInUserData] = useState({});
	const [hasError, setHasError] = useState(false);
	const [showCancelToaster, setCancelShowToaster] = useState(false);
	const [errorToaster, setErrorToaster] = useState(false);
	const [selectedFile, setSelectedFile] = useState();
	const [errorMessage, setErrorMessage] = useState();
	const [deletePriceCostID, setDeletePriceCostID] = useState(false);
	const [toasterMessage, setToasterMessage] = useState(false);
	const [toasterErrorMessage, setToasterErrorMessage] = useState(false);
	const [filePath, setFilePath] = useState("");
	const [fName, setFName] = useState("");
	useEffect(() => {
		getDrugPriceDetails();
		if (localStorage.getItem("userData")) {
			setLoggedInUserData(JSON.parse(localStorage.getItem("userData")));
		}
	}, []);
	const getDrugPriceDetails = async () => {
		setLoading(true);
		await _HttpServices
			.getData(`Api/Product/GetPriceSales`)
			.then((response) => {
				if (response.data) {
					let drugPriceDetailsList = response.data;
					let activeRecords = [];
					let InactiveRecords = [];
					if (drugPriceDetailsList.length > 0) {
						drugPriceDetailsList.map((res) => {
							res.CreatedOn = moment(res.CreatedOn).format("MM/DD/YYYY");
							res.TerminationDate = res.TerminationDate
								? moment(res.TerminationDate).format("MM/DD/YYYY")
								: null;
							res.LastModifiedOn = res.LastModifiedOn
								? moment(res.LastModifiedOn).format("MM/DD/YYYY")
								: null;
							// res.Active = res.Active? "Active" : "InActive";
							res.A340B =
								"$" +
								(res.A340B * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
							res.DAC =
								"$" +
								(res.DAC * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
							if (
								res.TerminationDate == null &&
								new Date(res.CreatedOn).setHours(0, 0, 0, 0) <=
									new Date().setHours(0, 0, 0, 0)
							) {
								res.Active = "Active";
								activeRecords.push(res);
							} else if (
								new Date(res.TerminationDate).setHours(0, 0, 0, 0) >=
									new Date().setHours(0, 0, 0, 0) &&
								new Date(res.CreatedOn).setHours(0, 0, 0, 0) <=
									new Date().setHours(0, 0, 0, 0)
							) {
								res.Active = "Active";
								activeRecords.push(res);
							} else {
								res.Active = "InActive";
							}
							// if (res.TerminationDate == null && (new Date(res.CreatedOn).setHours(0,0,0,0) > new Date().setHours(0,0,0,0))) {
							//   // setactivDrugPriceList(drugPriceDetailsList)
							//   // res.Active = 'Active';
							//   activeRecords.push(res)
							// }
							// else{
							//   InactiveRecords.push(res)
							// }
						});
					}
					setDrugPriceList(drugPriceDetailsList);
					// setinactivDrugPriceList(InactiveRecords)
					setactivDrugPriceList(activeRecords);
					setLoading(false);
				}
			})
			.catch((e) => {
				setHasError(true);
				setLoading(false);
			});
	};

	const columns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 80,
			Cell: ({ row: { original } }) => (
				<Fragment>
					{/* {loggedInUserData.RoleID !== 2 && ( */}
					{original.Active === "Active" ? (
						<Button
							style={{ color: "#3b61ad" }}
							variant="link"
							title="Active"
							onClick={() => deletePriceCost(original)}
							className="grid-action-btn"
						>
							{/* <IoMdTrash className="icon" /> */}
							<IoIosCheckmarkCircle className="icon" />
						</Button>
					) : (
						<Button
							style={{ color: "#3b61ad" }}
							variant="link"
							title="Inactivated"
							disabled
							className="grid-action-btn"
						>
							{/* <IoMdTrash className="icon" /> */}
							<IoIosCheckmarkCircle className="icon" />
						</Button>
					)}
					{/* )} */}
				</Fragment>
			),
		},
		{
			Header: "NDC",
			accessor: "NDC",
			filter: "NDC",
			sortType: "basic",
			width: 200,
		},
		{
			Header: "Product",
			accessor: "DrugName",
			filter: "DrugName",
			sortType: "basic",
		},
		{
			Header: "Vendor Name",
			accessor: "Vendorname",
			filter: "Vendorname",
			sortType: "basic",
		},
		{
			Header: "Contract Price ",
			accessor: "A340B",
			filter: "A340B",
			sortType: "basic",
		},
		{
			Header: "DAC/WAC",
			accessor: "DAC",
			filter: "DAC",
			sortType: "basic",
		},
		{
			Header: "Account Type",
			accessor: "IDAccountType",
			filter: "IDAccountType",
			sortType: "basic",
		},
		{
			Header: "Contract ",
			accessor: "ContractReferenceID",
			filter: "ContractReferenceID",
			sortType: "basic",
		},
		{
			Header: "Effective Date ",
			accessor: "CreatedOn",
			filter: "CreatedOn",
			sortType: "basic",
		},
		{
			Header: "Termination Date",
			accessor: "TerminationDate",
			filter: "TerminationDate",
			sortType: "basic",
		},
		{
			Header: "User",
			accessor: "CreatedBy",
			filter: "CreatedBy",
			sortType: "basic",
		},
		// {
		//   Header: "Inserted Date",
		//   accessor: "CreatedOn",
		//   filter: "CreatedOn",
		//   sortType: "basic",
		// },
		{
			Header: "Status ",
			accessor: "Active",
			filter: "Active",
			sortType: "basic",
			// Cell: ({ row: { original } }) => (
			//   <Fragment>
			//     {original.TerminationDate == null ?
			//         <span>Active</span>
			//         :original.TerminationDate != null ? <span>In Active</span> : ''
			//     }
			//   </Fragment>
			// ),
		},
	];
	let newColumn;
	if (loggedInUserData.RoleID == 2) {
		newColumn = columns.slice(0);
		newColumn.splice(0, 1);
	} else {
		newColumn = columns;
	}
	const deletePriceCost = (original) => {
		setDeletePriceCostID(original.NDC);
		setCancelShowToaster(true);
	};
	const deletePriceUpdateHandler = () => {
		setLoading(true);
		_HttpServices
			.postData(
				endPoints.deleteDrugPrice +
					deletePriceCostID +
					"&modifiedBy=" +
					loggedInUserData.UserName
			)
			.then((response) => {
				if (response.data) {
					setErrorToaster(false);
					setLoading(false);
					setToasterMessage(true);
					setShowToaster(true);
					// setHolidayDelete(true);
					// setCancelShowToaster(false)
					setErrorMessage(null);
					setCancelShowToaster(false);
					getDrugPriceDetails();
				}
			})
			.catch((error) => {
				setLoading(false);
				setToasterErrorMessage(true);
				setCancelShowToaster(false);
			});
	};
	const onFileChange = (event) => {
		setSelectedFile(event.target.files[0]);
	};

	// const onFileCancel = event => {
	//   setSelectedFile("")
	// }
	const onFileUpload = () => {
		// Create an object of formData
		if (selectedFile) {
			if (selectedFile.name === "DrugPriceImport.xlsx") {
				const formData = new FormData();
				// Update the formData object
				formData.append("myFile", selectedFile, selectedFile.name);

				setLoading(true);

				_HttpServices
					.postData("Api/Product/ImportDrugPriceExcel", formData)
					.then((data) => {
						if (data.data === "") {
							setLoading(false);
							setErrorToaster(false);
							setErrorMessage("File uploaded successfully");
							setShowToaster(true);
							getDrugPriceDetails();
							setSelectedFile(null);
							document.getElementById("actual-btn").value = null;
							setFName("");
							setFilePath("");
						}
					})
					.catch((e) => {
						setLoading(false);
						setErrorToaster(true);
						setErrorMessage(e.response.data.Message);
						setShowToaster(true);
						setSelectedFile(null);
						document.getElementById("actual-btn").value = null;
						setFName("");
						setFilePath("");
					});
			} else {
				setErrorToaster(true);
				setErrorMessage("Invalid File Name.");
				setShowToaster(true);
				document.getElementById("actual-btn").value = null;
				setFName("");
				setFilePath("");
			}
		} else {
			setErrorToaster(true);
			setErrorMessage("Please select a file");
			setShowToaster(true);
			setFName("");
			setFilePath("");
		}
	};
	const onToasterClose = () => {
		setShowToaster(false);
		setToasterErrorMessage(false);
		setToasterMessage(false);
	};
	//  const onclick = () => {
	//    setSelectedFile("");
	//  }

	const uploadOnChange = (event) => {
		let value = event.target.value;
		setSelectedFile(event.target.files[0]);
		setFilePath(value);
		let name = value;
		let lastIndex = name.lastIndexOf("\\");
		if (lastIndex >= 0) {
			name = name.substring(lastIndex + 1);
			setFName(name);
		}
	};
	return (
		<div>
			{/* Toaster */}
			<Toast
				className={
					errorToaster ? "err-toaster custom-toaster" : "custom-toaster"
				}
				onClose={() => onToasterClose()}
				show={showToaster}
				delay={2500}
				autohide
				// className="custom-toaster"
			>
				<Toast.Body>{errorMessage}</Toast.Body>
				{toasterMessage ? (
					<Toast.Body>Drug Price Inactivated successfully</Toast.Body>
				) : (
					""
				)}
				{toasterErrorMessage ? (
					<Toast.Body>Drug Price not Inactivated, please try again.</Toast.Body>
				) : (
					""
				)}
			</Toast>
			<Modal
				show={showCancelToaster}
				onHide={() => setCancelShowToaster(false)}
				size="lm"
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<img
							src="holder.js/20x20?text=%20"
							className="rounded mr-3"
							alt=""
						/>
						<strong className="confirm-top-align">
							Are you sure you want to Inactive the record?
						</strong>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p className="ml-2">
						{" "}
						<strong>Note:</strong> Inactive records cannot be active again.
					</p>
				</Modal.Body>
				<Modal.Footer>
					{/* onClick={forgotPasswordHandle} */}
					<div className="text-right mt-2">
						<Button onClick={() => deletePriceUpdateHandler()}>
							<IoMdDoneAll className="icon btn-icon" />
							Yes
						</Button>
						<Button
							variant="danger"
							className="ml-3 btn-sm"
							onClick={() => setCancelShowToaster(false)}
						>
							<IoIosClose className="icon btn-icon" />
							No
						</Button>
					</div>
				</Modal.Footer>
			</Modal>
			<div>
				{drugPriceList.length > 0 ? (
					<div className="download-btns">
						{
							<Button
								onClick={() => getExcel(columns, activDrugPriceList, fileName)}
							>
								<IoMdDownload className="icon btn-icon" />
								Download Active Drug Price Excel
							</Button>
						}
						{
							<Button
								className="ml-2"
								onClick={() => getExcel(columns, drugPriceList, fileName)}
							>
								<IoMdDownload className="icon btn-icon" />
								Download Drug Price Excel
							</Button>
						}
					</div>
				) : null}
			</div>
			{loggedInUserData.RoleID == 1 ? (
				<div>
					<div className="file-upload-wrap">
						<form>
							<label for="actual-btn" className="fu-label">
								Choose File
							</label>

							<input
								type="file"
								id="actual-btn"
								className="d-none"
								onChange={(e) => uploadOnChange(e)}
								accept=".xls,.xlsx"
							/>
							<Button
								type="button"
								onClick={onFileUpload}
								disabled={filePath.length > 0 ? false : true}
								className="ml-3 fu-submit-btn"
							>
								<IoIosCloudUpload className="icon btn-icon" /> Upload File
							</Button>
						</form>
						<div>
							{/* {filePath.length > 0 ? <a href="D:\0.shekar\Projects\TAP\docs\DrugPriceImport.xlsx">{fName}</a> : <span className="ml-2 mt-2 d-block" id="filename">No file chosen.</span>} */}
							{filePath.length > 0 ? (
								<span>{fName}</span>
							) : (
								<span className="ml-2 mt-2 d-block" id="filename">
									No file chosen.
								</span>
							)}
						</div>
					</div>
					{/* <div className="card-body" style={{ paddingTop: '38px' }}>
            <input type="file" id="selectFile" onChange={onFileChange} accept=".xls,.xlsx" className="overflow-hidden" />

            <Button type="submit" onClick={onFileUpload}>
              Upload
              </Button>
            {/* <Button type="reset" > 
                  Cancel  
                  onClick={e => (e.target.value = null)} onClick={onclick}
              </Button>  

          </div> */}
				</div>
			) : (
				""
			)}

			<div className="users-grid-wrap">
				<div className="card pt-3">
					<div className="card-body">
						{drugPriceList.length > 0 ? (
							<ReactTable
								columns={newColumn}
								data={drugPriceList}
								defaultPageSize={10}
							/>
						) : (
							<div className="no-data">No data found.</div>
						)}
					</div>
				</div>
			</div>
			{loading ? <Loader /> : null}
		</div>
	);
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
	loading: state.users.loading,
	login: state.users.login,
	users: state.users.users,
	hasErrors: state.users.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(PriceUpdate);
